import { CursedWeaponsEffect } from 'game/extended/creatures/goblins/abilities/cursed_weapons/cursed_weapons_effect'

export default {
    events: {},
    effects: {
        CursedWeaponsEffect
    },
}